// Copyright: IQGeo Limited 2010-2019
// Adapted from Leaflet (https://github.com/Leaflet/Leaflet)
import _ from 'underscore';

/**
 * Provides classical inheritance model. To be inherited by myWorld classes<br/>
 * Provides localisation methods
 * @name MywClass
 * @constructor
 * @mixes LocalisationMixin
 */
const MywClass = function() {};

MywClass.extend = function(className, props) {
    if (props === undefined) {
        props = className;
        className = '';
    }

    className = (className || '').replace(/\W/g, ''); // Remove spaces and non-letters

    // extended class with the new prototype
    const NewClass = eval(`var NewClass = function ${className}() {

        // call the constructor
        if (this.initialize) {
            this.initialize.apply(this, arguments);
        }

        // call all constructor hooks
        if (this._initHooks) {
            this.callInitHooks();
        }
    };NewClass;`);

    // instantiate class without calling constructor
    const F = function() {};
    F.prototype = this.prototype;

    const proto = new F();
    proto.constructor = NewClass;

    NewClass.prototype = proto;

    //inherit parent's statics
    for (const key in this) {
        if (this.hasOwnProperty(key) && key !== 'prototype') {
            NewClass[key] = this[key];
        }
    }

    // mix static properties into the class
    if (props.statics) {
        _.extend(NewClass, props.statics);
        delete props.statics;
    }

    // mix includes into the prototype
    if (props.includes) {
        _.extend.apply(null, [proto].concat(props.includes));
        delete props.includes;
    }

    // merge options
    if (props.options && proto.options) {
        props.options = _.extend({}, proto.options, props.options);
    }

    // mix given properties into the prototype
    _.extend(proto, props);

    proto._initHooks = [];

    const parent = this;
    // jshint camelcase: false
    NewClass.__super__ = parent.prototype;

    // add method for calling all hooks
    proto.callInitHooks = function() {
        if (this._initHooksCalled) {
            return;
        }

        if (parent.prototype.callInitHooks) {
            parent.prototype.callInitHooks.call(this);
        }

        this._initHooksCalled = true;

        for (let i = 0, len = proto._initHooks.length; i < len; i++) {
            proto._initHooks[i].call(this);
        }
    };

    return NewClass;
};

// method for adding properties to prototype
MywClass.include = function(props) {
    _.extend(this.prototype, props);
};

// merge new default options to the Class
MywClass.mergeOptions = function(options) {
    _.extend(this.prototype.options, options);
};

// add a constructor hook
MywClass.addInitHook = function(fn, ...args) {
    // (Function) || (String, args...)
    const init =
        typeof fn === 'function'
            ? fn
            : function() {
                  this[fn](...args);
              };

    this.prototype._initHooks = this.prototype._initHooks || [];
    this.prototype._initHooks.push(init);
};

MywClass.prototype.messageGroup = 'MywClass';

//ENH: move options related methods to Mixin?

MywClass.prototype.setOptions = function(options) {
    if (this.options && this.options.v) options = this.upgradeOptionsTo(this.options.v, options);
    this.options = _.extend({}, this.options, options);
    return this.options;
};

MywClass.prototype.upgradeOptionsTo = function(targetVersion, options) {
    for (let v = options.v || 1; v < targetVersion; v++) {
        const method = this[`upgradeOptionsToV${v + 1}`];
        if (method) options = method.call(this, options);
        else console.log(`Missing method upgradeOptionsToV${v + 1} on `, this);
    }
    return options;
};

export default MywClass;
